var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteTimeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66663C14.6026 1.66663 18.3334 5.39746 18.3334 9.99996C18.3334 14.6025 14.6026 18.3333 10.0001 18.3333C5.39758 18.3333 1.66675 14.6025 1.66675 9.99996C1.66675 5.39746 5.39758 1.66663 10.0001 1.66663ZM10.0001 3.33329C8.23197 3.33329 6.53628 4.03567 5.28604 5.28591C4.03579 6.53616 3.33341 8.23185 3.33341 9.99996C3.33341 11.7681 4.03579 13.4638 5.28604 14.714C6.53628 15.9642 8.23197 16.6666 10.0001 16.6666C11.7682 16.6666 13.4639 15.9642 14.7141 14.714C15.9644 13.4638 16.6667 11.7681 16.6667 9.99996C16.6667 8.23185 15.9644 6.53616 14.7141 5.28591C13.4639 4.03567 11.7682 3.33329 10.0001 3.33329ZM10.0001 4.99996C10.2042 4.99999 10.4012 5.07492 10.5537 5.21056C10.7063 5.34619 10.8037 5.53308 10.8276 5.73579L10.8334 5.83329V9.65496L13.0892 11.9108C13.2387 12.0608 13.3255 12.262 13.3319 12.4736C13.3384 12.6852 13.2641 12.8914 13.124 13.0502C12.984 13.209 12.7888 13.3085 12.578 13.3286C12.3673 13.3487 12.1567 13.2878 11.9892 13.1583L11.9109 13.0891L9.41091 10.5891C9.2814 10.4595 9.19822 10.2908 9.17425 10.1091L9.16675 9.99996V5.83329C9.16675 5.61228 9.25455 5.40032 9.41083 5.24404C9.56711 5.08776 9.77907 4.99996 10.0001 4.99996Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteTimeLine);
export default __webpack_public_path__ + "static/media/mingcute_time-line.02ee24a7619f5afbbcc38f37feddd414.svg";
export { ForwardRef as ReactComponent };